import { RouterModule } from '@angular/router';
import { AuthenticateComponent } from './components/authenticate/authenticate.component';
import { InitiateComponent } from './components/initiate/initiate.component';
import { SSOComponent } from './components/sso/sso.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
const routes = [
    {
        path: 'sso', // 'sso?token&id_token&connection&EncryptedToken&SiteCode&Signature&Role&log',
        component: SSOComponent
    },
    {
        path: 'initiate/:connection', //'initiate/:connection?scope&log',
        component: InitiateComponent
    },
    {
        path: 'authenticate/:realmName', //'authenticate/:realmName?code&scope&log',
        component: AuthenticateComponent
    }
];
export class AppRoutingModule {
    static { this.ɵfac = function AppRoutingModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AppRoutingModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AppRoutingModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [RouterModule.forRoot(routes), RouterModule] }); }
}
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(AppRoutingModule, { imports: [i1.RouterModule], exports: [RouterModule] }); })();
